<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 12V6H11V12H5V13H11V19H12V13H18V12H12Z" fill="#71718E"/>
</svg>
</template>